import React from 'react';

import classnames from 'classnames';

import ribbon from 'assets/images/featured-ribbon.svg';

import Image from 'shared/components/Image';
import ExternalLink from 'shared/components/ExternalLink';

import { LOGOS } from './constants';

import styles from './styles.module.scss';

class UsedBy extends React.Component {
  render() {
    return (
      <div className={classnames(styles.wrapper, 'container')}>
        <div className={styles.divider}>
          <div className={styles.ribbon}>
            <Image src={ribbon} height="50" width="38" />
          </div>
        </div>

        <div className={styles.title}>As used by</div>

        <div className={styles.usedByContainer}>
          <div className={styles.logos}>
            {LOGOS.map(logo => (
              <ExternalLink href={logo.url}>
                <Image src={logo.image} />
              </ExternalLink>
            ))}
          </div>
        </div>
        <div className={styles.divider} />
      </div>
    );
  }
}

export default UsedBy;
